import {
  composeClassNames,
  ifDefined,
  withDefault,
} from "@faedev/editor-utils";
import { useRouter } from "next/router";
import ContentSection from "src/components/ContentSection";
import Footer from "src/components/Footer";
import Footers from "src/components/Footers";
import Gallery from "src/components/Gallery";
import Header from "src/components/Header";
import Headers from "src/components/Headers";
import InstructorIntroduction from "src/components/InstructorIntroduction";
import Page from "src/components/Page";
import Preloader from "src/components/Preloader";
import ProfileHead from "src/components/ProfileHead";
import ValidateContent from "src/components/ValidateContent";
import VideoList from "src/components/VideoList";
import constants from "src/constants";
import defaultThumbnail from "src/functions/defaultThumbnail";
import getOg from "src/functions/getOg";
import { mapContentToVideoCards } from "src/functions/mapContentToVideoCards";
import profileNameText from "src/functions/profileNameText";
import translate from "src/functions/translate";
import { sPageInstructor } from "src/styles/sPageInstructor.module.scss";

export default function Profile({ dProfile }) {
  var { locale: lang } = useRouter();

  var profileTitle = dProfile
    ? profileNameText(
        dProfile.client?.name,
        dProfile.client?.surname,
        dProfile.nickname,
        dProfile.type
      )
    : translate(constants.Marketing.ogTitle, lang);
  var profileLabel = dProfile
    ? dProfile.label
    : translate(constants.Marketing.ogDescription, lang);

  const ogData = getOg(
    lang,
    `profile`,
    profileTitle,
    profileLabel,
    withDefault(dProfile ? dProfile.thumbnail : ``, defaultThumbnail()).url
  );

  return (
    <>
      <Headers data={ogData} />
      <Page className={composeClassNames([sPageInstructor, "page-instructor"])}>
        <Header />
        {dProfile ? (
          <ValidateContent
            element={`Instructor`}
            blocked={withDefault(dProfile.blocked, true)}
            verified={ifDefined(
              dProfile.verified,
              (value) => value.verified,
              () => false
            )}
          >
            <ProfileHead
              motiveImg={dProfile.motive}
              profileImg={dProfile.thumbnail}
              experienceLevel={dProfile.experience?.level}
            />
            <ContentSection className={`in-detail`} fluid={`xl`}>
              <InstructorIntroduction
                data={dProfile}
                className={
                  dProfile.programs.length > 0 || dProfile.lectures.length > 0
                    ? `border-bottom`
                    : null
                }
              />
              {dProfile.programs && dProfile.programs.length > 0 ? (
                <VideoList
                  data={mapContentToVideoCards(dProfile.programs, dProfile)}
                  type={`preview`}
                  size="lg"
                  title={
                    {
                      instructor: translate(`Instructor series`, lang),
                      studio: translate(`Studio series`, lang),
                      festival: translate(`Festival events`, lang),
                    }[dProfile.type]
                  }
                  showPrivate={dProfile.private}
                />
              ) : null}
              {dProfile.lectures && dProfile.lectures.length > 0 ? (
                <VideoList
                  data={mapContentToVideoCards(dProfile.lectures, dProfile)}
                  type={`preview`}
                  size="nm"
                  title={
                    {
                      instructor: translate(`Instructor classes`, lang),
                      studio: translate(`Studio classes`, lang),
                      festival: translate(`Festival classes`, lang),
                    }[dProfile.type]
                  }
                  showPrivate={dProfile.private}
                />
              ) : null}
            </ContentSection>
            <Gallery
              data={dProfile.gallery}
              title={
                {
                  instructor: translate(`Instructor gallery`, lang),
                  studio: translate(`Studio gallery`, lang),
                  festival: translate(`Festival gallery`, lang),
                }[dProfile.type]
              }
            />
            {/*<Instagram
              userId={slug}
              data={dDataInstagramMedia}
              title={translate(`Instagram photos`, lang)}
            />*/}
          </ValidateContent>
        ) : (
          <Preloader />
        )}
        <Footer />
      </Page>
      <Footers />
    </>
  );
}

export const getServerSideProps = async (context) => {
  const slug = context.params.slug;
  const dProfile = await fetch(
    `${constants.Paths.apiUrl}/profiles/${slug}`
  ).then((res) => {
    if (res.ok) {
      return res.json();
    } else {
      throw new Error("API Error");
    }
  });
  return {
    props: { dProfile },
  };
};
